import React from 'react';
import MobileApps from '../../components/AdminNext/MobileApps';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Mobile apps — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <MobileApps />
      </HeadLessLayout>
    )
  };
}

export default action;
